import indexedDBService from '../indexedDBService';
import storageService from '../storageService';

const RUM_DB_NAME = 'RumEventsDB';
const RUM_DB_STORE = 'RumEventsStore';
const RUM_KEY_PATH = 'id';

export interface RumEventRecord {
    id: string;
    streamName: string;
    type: string;
    eventData: unknown;
    ts: number;
}

const now = () => Date.now();

const getStreamName = (): string => {
    const stream = storageService.getLogStreamNameFromLocalStorage();

    if (!stream) {
        return `stream-${Date.now()}`;
    }
    return stream;
};

const put = async (rec: RumEventRecord) =>
    indexedDBService.putDatabaseItem(RUM_DB_NAME, RUM_DB_STORE, RUM_KEY_PATH, rec);

const del = async (id: string) => indexedDBService.deleteDatabaseItemById(RUM_DB_NAME, RUM_DB_STORE, RUM_KEY_PATH, id);

const readAll = async (): Promise<RumEventRecord[]> =>
    ((await indexedDBService.getDatabaseData(RUM_DB_NAME, RUM_DB_STORE, RUM_KEY_PATH)) || []) as RumEventRecord[];

const addEventToIndexedDB = async (type: string, eventData: unknown): Promise<void> => {
    const streamName = getStreamName();
    const t = now();
    const rec: RumEventRecord = {
        id: `${streamName}:${t}:${crypto.getRandomValues(new Uint32Array(1))[0].toString(36)}`,
        streamName,
        type,
        eventData,
        ts: t,
    };

    await put(rec);
};

const listReadyForSend = async (): Promise<RumEventRecord[]> => {
    const streamName = getStreamName();
    const all = await readAll();

    return all.filter((r) => r.streamName === streamName).sort((a, b) => a.ts - b.ts);
};

const markSent = async (id: string): Promise<void> => {
    await del(id);
};

export default {
    addEventToIndexedDB,
    listReadyForSend,
    markSent,
};
